export default __webpack_public_path__ + "static/massage_spa-88afaf5fd2e33416390f5dde5307c82e.jpg";